import { CSSProperties, ChangeEvent, FocusEvent, ReactNode } from 'react';
import Text, { Ecolor } from '../text';
import './style.scss';
export const InputLabel = ({ label,required }: { label: string,required?:boolean }) => {
  return (
    <Text color={Ecolor.deep} required={required}>
      {label}
    </Text>
  )
}
interface InputFieldProps {
  type?: string;
  label?: string;
  placeholder?: string;
  value?: string | number;
  icon?: ReactNode;
  required?: boolean;
  error?: string;
  name?: string;
  className?: string;
  style?: CSSProperties;
  disabled?: boolean;
  autoFocus?: boolean;
  min?: string | number;
  max?: string | number;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
}
const InputField = ({
  type = 'text',
  label = '',
  value = '',
  placeholder = '',
  onChange,
  onFocus,
  icon,
  error,
  required,
  className,
  name,
  style = {},
  disabled = false,
  autoFocus = false,
  min,
  max
}: InputFieldProps) => {
  return (
    <>
      <div className={`${className} input-field`} style={style}>
        {label !== "" &&
          <Text color={Ecolor.deep} required={required}>
            {label}
          </Text>}
        <input
          className={`textbox ${icon && 'with-icon'}`}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          data-error={error && error.length > 0}
          disabled={disabled}
          autoFocus={autoFocus}
          min={min}
          max={max}
        />
        {icon && <span className="icon-container">{icon}</span>}
        {error && error !== '' && <span className="error">{error}</span>}
      </div>
    </>
  );
};
export default InputField;
